import axios from "@/axios"
const namespaced = true;
const actions = {};
const defaultState = () => {
    return {
        reports: [],
        status: "",
        per: 10000,
        vehicles: [],
        loading: false
    };
};
const state = defaultState();
const mutations = {
    SET_VEHICLES(state, vehicles) {
        state.vehicles = vehicles;
    },
    SET_LOADING(state, loading) {
        state.loading = loading
    },
    ADD_REPORT(state, payload) {
        state.reports = [payload, ...state.reports]
    },
    SET_REPORTS(state, reports) {
        state.reports = reports;
    },
    SET_STATUS(state, status) {
        state.status = status
    }
};
const getters = {};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters,
};
